<script>
import * as moment from 'moment'
import ExpressionCalculator from '@/components/ExpressionCalculator.vue';
import LayerPersonChooser from '@/layer/components/LayerPersonChooser.vue';

export default {
  components: {
    ExpressionCalculator,
    LayerPersonChooser,
  },

  props: {
    batch: { type: Object, required: true },
  },

  data: () => ({
    date: moment().format('YYYY-MM-DD'),
    person: '',
    mortalities: 0,
    mortalitiesWereZero: false,
    prePeakKgs: '',
    sizes: [
      { name: 'SuperJumbo', count: 0, expression: '0' },
      { name: 'Jumbo', count: 0, expression: '0' },
      { name: 'XLarge', count: 0, expression: '0' },
      { name: 'Large', count: 0, expression: '0' },
      { name: 'BigMedium', count: 0, expression: '0' },
      { name: 'SmallMedium', count: 0, expression: '0' },
      { name: 'Small', count: 0, expression: '0' },
      { name: 'Broken', count: 0, expression: '0' },
    ],
  }),

  computed: {
    validationError() {
      if (!this.date) return 'Please choose a Placed Date';
      if (!this.person) return 'Please choose a Person';
      if (!this.mortalitiesWereZero && (isNaN(this.mortalities) || Number(this.mortalities) === 0)) return 'Please enter the Mortalities (or choose "There were no mortalities")';
      if (!this.sizes.find(x => x.count > 0)) return 'Please fill in at least one of the sizes';

      return undefined;
    },

    showPrePeakKgs() { return true; }, //return this.batch && this.batch.remaining_pre_peak_kgs > 0 },

    submitPayload() {
      let sizesDict = {};
      this.sizes.filter(x => x.count > 0).forEach(x => { sizesDict[x.name] = x.count });

      return {
        date: this.date,
        person: this.person,
        mortalities: this.mortalitiesWereZero ? 0 : this.mortalities,
        pre_peak_kg: this.prePeakKgs || 0,
        sizes: sizesDict,
      };
    },
  },

  watch: {
    batch(to) {
      this.prePeakKgs = '';
    },
  },

  methods: {
    clearForm() {
      this.date = moment().format('YYYY-MM-DD');
      this.person = '';
      this.mortalitiesWereZero = false;
      this.mortalities = 0;
      this.prePeakKgs = '';
      this.sizes.forEach(x => { x.count = 0; x.expression = '0' });
    },

    onFormSubmitSuccess(newRecord) {
      let usedDate = this.date;

      this.clearForm();

      this.$emit('added', { usedDate: usedDate, newRecord: newRecord, batch: this.batch });
    },

    onCancelledForm() {
      this.$router.push({ name: 'form-cancelled' });
    },
  },
}
</script>

<template>
  <api-form
    method="post"
    :url="`v1/layers/batches/${encodeURIComponent(batch.name)}/packing-records`"
    :payload="submitPayload"
    submit-text="Add"
    :validation-error="validationError"
    :make-success-message="() => `Packing record ${date} was successfully added to batch ${batch.name}.`"
    @success="onFormSubmitSuccess"
    @cancel="onCancelledForm">

    <b-card>
      <b-form-group label="Date" :label-for="`date-${_uid}`">
        <b-form-input :id="`date-${_uid}`" v-model="date" type="date" placeholder="Date..." required></b-form-input>
      </b-form-group>

      <layer-person-chooser v-model="person" required />

      <transition name="fade">
        <div v-if="person">
          <b-form-group v-if="showPrePeakKgs" label="Pre-Peak (kg)" :label-for="`pre-peak-kg-${_uid}`">
            <b-form-input
              :id="`pre-peak-kg-${_uid}`"
              v-model="prePeakKgs"
              type="number"
              min="1"
              step="any"
              @focus="$event.target.select()"></b-form-input>

            <div class="text-muted small"> {{batch.remaining_pre_peak_kgs}} kg remaining </div>
          </b-form-group>

          <div class="form-group mb-0">
            <transition name="fade" mode="out-in">
              <b-form-group label="Mortalities" :label-for="`mortalities-${_uid}`">
                <b-form-input :id="`mortalities-${_uid}`" v-model="mortalities" type="number" min="0" step="1" :required="!mortalitiesWereZero" :disabled="mortalitiesWereZero" @focus="$event.target.select()"></b-form-input>
              </b-form-group>
            </transition>
          </div>

          <div>
            <b-form-checkbox v-model="mortalitiesWereZero" class="mt-1 mb-3">No mortalities</b-form-checkbox>
          </div>
        </div>
      </transition>
    </b-card>

    <div class="mt-3"></div>

    <transition name="fade">
      <b-card v-if="person">
        <b-form-group v-for="size in sizes" :key="size.name" :label="size.name" :label-for="`size-${_uid}-${size.name}`">

          <ExpressionCalculator
            :expression="size.expression"
            @result="size.count = $event" />

          <b-input-group>
            <b-form-input
              :id="`size-${_uid}-${size.name}`"
              v-model="size.expression"
              type="text"
              min="0"
              @focus="$event.target.select()"></b-form-input>

            <b-input-group-text
              v-if="size.expression != size.count"
              slot="append"> = {{size.count}} </b-input-group-text>

          </b-input-group>
        </b-form-group>
      </b-card>
    </transition>

    <div class="mt-3"></div>

  </api-form>
</template>



// WEBPACK FOOTER //
// src/layer/components/AddPackingRecord.vue